// extracted by mini-css-extract-plugin
export default {"PremierButton":"PremierButton_PremierButton"};